import { IConfigSeller } from '@/models/configSeller'
import { motion } from 'framer-motion'
import { useSelector } from 'react-redux'
import Certificate from './components/Certificate'
import Checklist from './components/Checklist'
import Client from './components/Client'
import Contract from './components/Contract'
import Detail from './components/Detail'
import DeviceMobile from './components/DeviceMobile'
import DeviceOther from './components/DeviceOther'
import Discounts from './components/Discounts'
import Header from './components/Header'
import History from './components/History'
import Multimedia from './components/Multimedia'
import Questions from './components/Questions'
import { TradeinProvider } from './context/TradeinContext'
import { useTradeinContext } from './hooks/useTradeinContext'
import { webApiService } from '@/services'
import { IAppStore } from '@/models/store.model'
import { useAppDispatch } from '@/store/store'
import { updateUser } from '@/store/user'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import IAEvaluation from './components/IAEvaluation'
import Extras from './components/Extras'
import NovabencEvaluation from './components/NovabenchEvaluation'
import OsiptelEvaluation from './components/OsiptelEvaluation'

const TradeInPageContext = () => {
  const { ctx, saveCtx } = useTradeinContext()
  console.log('ctx => ', ctx)
  const configSeller = useSelector((store: { config: IConfigSeller }) => store.config)
  const isSamsungPeru = configSeller.config.s3.FOLDER_APP === 'ti_samsung_pe'
  const isSamsungRomPeru = configSeller.config.s3.FOLDER_APP === 'ti_samsung_pe_rom'
  const isFalabellaChile = configSeller.config.s3.FOLDER_APP === 'ti_falabella'
  const isMacstoreMexico = configSeller.config.s3.FOLDER_APP === 'ti_macstore'
  const hasIAEvaluation = configSeller.config.permisos.ENABLE_IAEVALUATION === 1 && configSeller.config.permisos.SBUS_IA_EVALUATION.includes(ctx.tradein.id_sbu)
  const isConsola = ctx.tradein.sbu === 'Consolas'
  const userState = useSelector((store: IAppStore) => store.user)
  const dispatch = useAppDispatch()
  const { id } = useParams()
  // const isNovabench = import.meta.env.VITE_ID_STORE_REMOVECHECKLIST !== '' && import.meta.env.VITE_ID_STORE_REMOVECHECKLIST !== undefined && import.meta.env.VITE_ID_STORE_REMOVECHECKLIST.split(',').includes(String(userState.id_store)) && isFalabellaChile && ctx.tradein.sbu === 'Notebook'
  const isNovabench = (isMacstoreMexico || isFalabellaChile) && ctx.tradein.sbu === 'Notebook'

  const loadUSerStore = () => {
    saveCtx({ ...ctx, loading: true })
    webApiService.getStoreByUser(userState.id).then(res => {
      if (res.data.length > 0) {
        dispatch(updateUser({ ...userState, id_store: res.data[0].id }))
      }
    })
      .catch((error) => {
        saveCtx({ ...ctx, loading: false })
        console.log('Error loading data:', error)
      })
  }

  useEffect(() => {
    loadUSerStore()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])

  return (
    <motion.div
      initial={{ y: 10, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: -10, opacity: 0 }}
      transition={{ duration: 0.3 }} className='space-y-4'
    >
      <Header />
      <div className='grid grid-cols-12 gap-4 mt-4'>
        <div className='col-span-12 md:col-span-3'>
          <Detail />
        </div>
        <div className='col-span-12 md:col-span-9'>
          <Client />
          <div className='grid grid-cols-12 gap-4 mt-4'>
            <div className='col-span-12 md:col-span-8'>
              {ctx.tradein.sbu === 'Smartphone' || (ctx.tradein.sbu === 'Tablet' && ctx.tradein.brand === 'Apple') ? <DeviceMobile /> : <DeviceOther />}
            </div>
            <div className='col-span-12 md:col-span-4'>
              <History />
            </div>
          </div>
        </div>
      </div>
      <div className='grid grid-cols-12 gap-4 mt-4'>

        {ctx.tradein.id_status === 6 && (ctx.tradein.sbu === 'Smartphone' || (ctx.tradein.sbu === 'Tablet' && ctx.tradein.brand === 'Apple'))
          ? (
            <div className='col-span-12'><div className='text-sm p-4 bg-red-100 border border-red-300 rounded-md text-black'>Lo sentimos, este dispositivo no aprobó la evaluación de Phonecheck. Puede reenviar el código para realizar una nueva evaluación.</div></div>
            )
          : null}

        {
          ctx.tradein.id_status !== 6
            ? (
              <>
                <div className='col-span-12 md:col-span-12'>
                  <NovabencEvaluation />
                </div>
                <div className={configSeller.config.permisos.ENABLE_CHECK_BATTERY === 1 && (ctx.tradein.entry_form_status === 1 || ctx.tradein.certificate_theft === 'VALID') ? 'col-span-12 md:col-span-12' : 'col-span-12'}>
                  {ctx.tradein.sbu === 'Smartphone' || (ctx.tradein.sbu === 'Tablet' && ctx.tradein.brand === 'Apple')
                    ? <Certificate />
                    : <Checklist />}
                </div>

                {!isSamsungPeru &&
                  <div className='col-span-12'>
                    <Questions />
                  </div>}

                <div className='col-span-12'>
                  {hasIAEvaluation && ctx.tradein.serie !== null && ctx.tradein.serie !== '' && ctx.tradein.id_status !== 8 && (ctx.tradein.recalculate === '0' || ctx.tradein.wasRecalculated === 1) && (ctx.tradein.cancel_reason === 'El modelo evaluado no esta disponible' ? ctx.tradein.model === ctx.tradein.modelName : true) ? <IAEvaluation /> : null}
                </div>

                {isSamsungPeru &&
                  <div className='col-span-12'>
                    <Questions />
                  </div>}

                {
                  isSamsungRomPeru &&
                    <div hidden={hasIAEvaluation && ctx.tradein.grade_IA === null} className={ctx.tradein.id_status !== 1 ? 'col-span-12 md:col-span-6' : 'col-span-12'}>
                      <OsiptelEvaluation />
                    </div>
                }
                {isSamsungPeru && !isConsola && !isSamsungRomPeru &&
                  <div hidden={hasIAEvaluation && ctx.tradein.grade_IA === null} className={ctx.tradein.id_status !== 1 ? 'col-span-12 md:col-span-6' : 'col-span-12'}>
                    <Discounts />
                  </div>}

                {/* {
                  configSeller.config.permisos.ENABLE_CHECK_BATTERY === 1 && (ctx.tradein.entry_form_status === 1 || ctx.tradein.certificate_theft === 'VALID')
                    ? (
                      <div className='col-span-12 md:col-span-6'>
                        <Discounts />
                      </div>
                      )
                    : null
                } */}
                {!isSamsungPeru && !isNovabench && !isConsola && !isSamsungRomPeru && !isMacstoreMexico
                  ? (
                    <div hidden={hasIAEvaluation && ctx.tradein.grade_IA === null} className={ctx.tradein.id_status !== 1 ? 'col-span-12 md:col-span-6' : 'col-span-12'}>
                      <Discounts />
                    </div>
                    )
                  : null}

                {
                    isSamsungRomPeru && ctx.tradein.osiptel_evaluation !== null && ctx.tradein.osiptel_evaluation !== 1 &&
                    // isSamsungRomPeru &&
                      <div hidden={hasIAEvaluation && ctx.tradein.grade_IA === null} className={ctx.tradein.id_status !== 1 ? 'col-span-12 md:col-span-6' : 'col-span-12'}>
                        <Discounts />
                      </div>
                  }
                {isMacstoreMexico && ctx.tradein.id_status === 4
                  ? (
                    <div hidden={(hasIAEvaluation && ctx.tradein.grade_IA === null) || (isMacstoreMexico && isNovabench)} className='col-span-12 md:col-span-6'>
                      <Discounts />
                    </div>
                    )
                  : null}
                <div hidden={!isConsola || (hasIAEvaluation && ctx.tradein.grade_IA === null)} className={ctx.tradein.id_status !== 1 ? 'col-span-12 md:col-span-6' : 'col-span-12'}>
                  <Extras />
                </div>

                {ctx.displayContract === 1 &&
                  <div className='col-span-6' hidden={(isNovabench && ctx.tradein.isBatteryHealthy && (isFalabellaChile || isMacstoreMexico) && [1].includes(ctx.tradein.id_status) && ctx.tradein.sbu === 'Notebook') || (hasIAEvaluation && ctx.tradein.grade_IA === null) || (isNovabench && (ctx.tradein.id_status === 1 || ctx.tradein.id_status === 2 || ctx.tradein.id_status === 4) && ctx.tradein.entry_form_status === 0) || (isSamsungRomPeru && (ctx.tradein.osiptel_evaluation === null || ctx.tradein.osiptel_evaluation === 1))}>
                    {/* // <div className='col-span-6' hidden={(hasIAEvaluation && ctx.tradein.grade_IA === null) || (isNovabench && (ctx.tradein.id_status === 1 || ctx.tradein.id_status === 2))}> */}
                    <Contract />
                  </div>}

                {isSamsungPeru &&
                  <div className='col-span-12' hidden={(hasIAEvaluation && ctx.tradein.grade_IA === null) || (isNovabench && (ctx.tradein.id_status === 1 || ctx.tradein.id_status === 2 || ctx.tradein.id_status === 4))}>
                    <Multimedia />
                  </div>}
                {/* {
                  (ctx.displayContract === 0 && ctx.tradein.id_status === 4 && ctx.tradein.isBatteryHealthy !== null) || (ctx.tradein.id_status !== 1 && ctx.tradein.id_status !== 2 && ctx.tradein.id_status !== 4)
                    ? (<div className='col-span-12'>  <Multimedia /> </div>)
                    : null
                } */}

                {!isSamsungPeru &&
                  <div className='col-span-12' hidden={(hasIAEvaluation && ctx.tradein.grade_IA === null) || (isNovabench && (ctx.tradein.id_status === 1 || ctx.tradein.id_status === 2 || ctx.tradein.id_status === 4)) || (isSamsungRomPeru && ctx.tradein.osiptel_evaluation === null) || (isSamsungRomPeru && (ctx.tradein.osiptel_evaluation === null || ctx.tradein.osiptel_evaluation === 1))}>
                    {/* // <div className='col-span-12' hidden={(hasIAEvaluation && ctx.tradein.grade_IA === null) || (isNovabench && (ctx.tradein.id_status === 1 || ctx.tradein.id_status === 2 || ctx.tradein.id_status === 4))}> */}
                    <Multimedia />
                  </div>}
              </>
              )
            : null
        }

      </div>
    </motion.div>
  )
}

const TradeInPage = () => {
  return (
    <TradeinProvider><TradeInPageContext /></TradeinProvider>
  )
}

export default TradeInPage
